export default __webpack_public_path__ + "static/media/logo.90be3d1b.svg";